import FieldWrapper from '~/utils/formik/FieldWrapper';
import FastFieldWrapper from '~/utils/formik/FastFieldWrapper';

import UnifiedTextField, { IUnifiedTextField } from './UnifiedTextField';

export const Field = {
  UnifiedTextField: FieldWrapper<IUnifiedTextField>(UnifiedTextField),
};

export const FastField = {
  UnifiedTextField: FastFieldWrapper<IUnifiedTextField>(UnifiedTextField),
};

export default {
  Field,
  FastField,
};
